import canChangeDepth from '../queries/canChangeDepth';
export default function shouldNormalizeDepth(node, editor, next) {
  if (node.object !== 'document') return next();
  editor.value.document.nodes.forEach(function (child) {
    var depth = child.getIn(['data', 'depth']);
    var shouldHaveDepth = canChangeDepth(null, child);

    if (!shouldHaveDepth && depth !== undefined) {
      editor.setNodeByKey(child.key, {
        data: child.data["delete"]('depth')
      });
    }
  });
  return next();
}